import { THeadCell } from 'common/types/table';

export function getDefaultHeadCell(headcells: THeadCell[]) {
    const defaultHeadCellResult = headcells.filter(
        (headCell) => headCell.default
    );

    return defaultHeadCellResult.length
        ? defaultHeadCellResult[0]
        : headcells[0];
}
